import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['selectAll']
  static values = { targetSelector: { type: String, default: 'input[type=checkbox]' } }

  declare selectAllTarget: HTMLInputElement
  declare hasSelectAllTarget: boolean
  declare targetSelectorValue: string

  connect (): void {
    const checkboxes = this.element.querySelectorAll<HTMLInputElement>(this.targetSelectorValue)
    checkboxes.forEach(cb => {
      cb.addEventListener('change', () => this.syncSelectAllState())
    })
  }

  toggleAll (): void {
    if (!this.hasSelectAllTarget) return

    const checkboxes = this.element.querySelectorAll<HTMLInputElement>(this.targetSelectorValue)
    checkboxes.forEach(cb => {
      if (!cb.disabled) cb.checked = this.selectAllTarget.checked
    })
    this.syncSelectAllState()
  }

  syncSelectAllState (): void {
    if (!this.hasSelectAllTarget) return

    const checkboxes = Array.from(
      this.element.querySelectorAll<HTMLInputElement>(this.targetSelectorValue)
    ).filter(cb => !cb.disabled)

    const checkedCount = checkboxes.filter(cb => cb.checked).length
    this.selectAllTarget.indeterminate = checkedCount > 0 && checkedCount < checkboxes.length
    this.selectAllTarget.checked = checkboxes.length > 0 && checkedCount === checkboxes.length
  }
}
